import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DialogPreviewAccountingComponent } from '@app/modules/statements/components/dialog-preview-accounting/dialog-preview-accounting.component';
import { SharedModule } from '../../shared/shared.module';
import { DialogPublishComponent } from './components/dialog-publish/dialog-publish.component';
import { DialogStatementsEditCommissionComponent } from './components/dialog-statements-edit-commission/dialog-statements-edit-commission.component';
import { DialogUnpublishComponent } from './components/dialog-unpublish/dialog-unpublish.component';
import { InputWithSliderComponent } from './components/input-with-slider/input-with-slider.component';
import { StatementTabsComponent } from './components/statement-tabs/statement-tabs.component';
import { StatementsAccountingConnectionFormMapAccountsComponent } from './components/statements-accounting-connection-form-map-accounts/statements-accounting-connection-form-map-accounts.component';
import { StatementsAccountingConnectionFormTrackingCategoriesComponent } from './components/statements-accounting-connection-form-tracking-categories/statements-accounting-connection-form-tracking-categories.component';
import { StatementsAccountingConnectionFormComponent } from './components/statements-accounting-connection-form/statements-accounting-connection-form.component';
import { StatementsCommissionsFormComponent } from './components/statements-commissions-form/statements-commissions-form.component';
import { StatementsOwnerFormComponent } from './components/statements-owner-form/statements-owner-form.component';
import { StatementsPropertyPickerComponent } from './components/statements-property-picker/statements-property-picker.component';
import { StatementsSetupFlowComponent } from './components/statements-setup-flow/statements-setup-flow.component';
import { StatementsTransactionFormComponent } from './components/statements-transaction-form/statements-transaction-form.component';
import { DialogAccountingSetupComponent } from './components/dialog-accounting-setup/dialog-accounting-setup.component';
import { PropertyComponent } from './pages/property/property.component';
import { StatementsPropertiesComponent } from './pages/statements-properties/statements-properties.component';
import { StatementsAccountingConnectionEditComponent } from './pages/statements-accounting-connection-edit/statements-accounting-connection-edit.component';
import { StatementsAccountingConnectionNewComponent } from './pages/statements-accounting-connection-new/statements-accounting-connection-new.component';
import { StatementsAccountingConnectionsComponent } from './pages/statements-accounting-connections/statements-accounting-connections.component';
import { StatementsAddEditOwnerComponent } from './pages/statements-add-edit-owner/statements-add-edit-owner.component';
import { StatementsCommissionsAddComponent } from './pages/statements-commissions-add/statements-commissions-add.component';
import { StatementsCommissionsEditComponent } from './pages/statements-commissions-edit/statements-commissions-edit.component';
import { StatementsCommissionsListComponent } from './pages/statements-commissions-list/statements-commissions-list.component';
import { StatementsDashboardComponent } from './pages/statements-dashboard/statements-dashboard.component';
import { StatementsOnboardingComponent } from './pages/statements-onboarding/statements-onboarding.component';
import { StatementsOwnersListComponent } from './pages/statements-owners-list/statements-owners-list.component';
import { StatementsStatementDetailComponent } from './pages/statements-statement-detail/statements-statement-detail.component';
import { StatementsTransactionAddComponent } from './pages/statements-transaction-add/statements-transaction-add.component';
import { TransactionTotalPipe } from './pipes/transaction-total.pipe';
import { StatementsTransactionEditComponent } from './pages/statements-transaction-edit/statements-transaction-edit.component';
import { StatementsTransactionsListComponent } from './pages/statements-transactions-list/statements-transactions-list.component';
import { StatementsRoutingModuleV2 } from './statements-routing.module';
import { StatementsAccountingConnectionFormAccountDropdownComponent } from './components/statements-accounting-connection-form-account-dropdown/statements-accounting-connection-form-account-dropdown.component';
import { StatementsTransactionsScheduledComponent } from './components/statements-transactions-scheduled/statements-transactions-scheduled.component';
import { RecurrenceSchedulePipe } from './pipes/recurrence-schedule.pipe';
import { StatementsAccountingConnectionFormOwnersComponent } from './components/statements-accounting-connection-form-owners/statements-accounting-connection-form-owners.component';
import { StatementsAdjustmentsComponent } from './pages/statements-adjustments/statements-adjustments.component';
import { AdjustmentPreviewPaneComponent } from './components/adjustment-preview-pane/adjustment-preview-pane.component';
import { StatementsAdjustmentsTableComponent } from './components/statements-adjustments-table/statements-adjustments-table.component';
import { AccountingUpsellComponent } from '@app/modules/statements/components/accounting-upsell/accounting-upsell.component';
import { DialogNewOwnerComponent } from './components/dialog-new-owner/dialog-new-owner.component';
import { DialogNewAgreementComponent } from './components/dialog-new-agreement/dialog-new-agreement.component';
import { StatementDetailCustomizeComponent } from './components/statement-detail-customize/statement-detail-customize.component';

@NgModule({
  declarations: [
    StatementsOnboardingComponent,
    StatementsSetupFlowComponent,
    StatementsDashboardComponent,
    StatementsStatementDetailComponent,
    StatementsOwnersListComponent,
    StatementsAddEditOwnerComponent,
    StatementsOwnerFormComponent,
    StatementsCommissionsListComponent,
    StatementsTransactionAddComponent,
    TransactionTotalPipe,
    StatementsTransactionsListComponent,
    StatementsCommissionsAddComponent,
    StatementsCommissionsFormComponent,
    StatementsPropertyPickerComponent,
    StatementsPropertiesComponent,
    PropertyComponent,
    StatementsCommissionsEditComponent,
    DialogStatementsEditCommissionComponent,
    StatementTabsComponent,
    InputWithSliderComponent,
    StatementsAccountingConnectionsComponent,
    DialogPublishComponent,
    DialogPreviewAccountingComponent,
    DialogUnpublishComponent,
    StatementsAccountingConnectionFormMapAccountsComponent,
    StatementsAccountingConnectionEditComponent,
    StatementsAccountingConnectionFormTrackingCategoriesComponent,
    StatementsAccountingConnectionNewComponent,
    StatementsAccountingConnectionFormComponent,
    StatementsTransactionFormComponent,
    StatementsTransactionEditComponent,
    StatementsAccountingConnectionFormAccountDropdownComponent,
    StatementsTransactionsScheduledComponent,
    RecurrenceSchedulePipe,
    StatementsAccountingConnectionFormOwnersComponent,
    StatementsAdjustmentsComponent,
    AdjustmentPreviewPaneComponent,
    DialogAccountingSetupComponent,
    StatementsAdjustmentsTableComponent,
    AccountingUpsellComponent,
    DialogNewOwnerComponent,
    DialogNewAgreementComponent,
    StatementDetailCustomizeComponent,
  ],
  imports: [CommonModule, StatementsRoutingModuleV2, SharedModule],
})
export class StatementsModule {}
